module.exports = __webpack_public_path__ + "static/media/decentralization.e31135b4.svg";